import { render, staticRenderFns } from "./UiChip.vue?vue&type=template&id=6f59e310&scoped=true"
import script from "./UiChip.vue?vue&type=script&lang=ts"
export * from "./UiChip.vue?vue&type=script&lang=ts"
import style0 from "./UiChip.vue?vue&type=style&index=0&id=6f59e310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f59e310",
  null
  
)

export default component.exports